import styled from '@emotion/styled'

import { BRAND_COLOR } from '@/constants/colors'

const BUTTON_HEIGHT_PX = 60
const BUTTON_RADIUS_PX = 16
const DISABLED_BG_COLOR = '#686a72'
const DISABLED_TEXT_COLOR = '#acaeb4'
const PRESSED_BG_COLOR = '#e94618'

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
  max-width: 100%;
  height: ${BUTTON_HEIGHT_PX}px;
  padding: 12px 16px;
  background-color: ${BRAND_COLOR};
  border: none;
  border-radius: ${BUTTON_RADIUS_PX}px;
  color: white;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.18px;
  cursor: pointer;
  transition: background-color 0.1s ease;

  &:active:not(:disabled) {
    background-color: ${PRESSED_BG_COLOR};
  }

  &:disabled {
    background-color: ${DISABLED_BG_COLOR};
    color: ${DISABLED_TEXT_COLOR};
    cursor: not-allowed;
  }
`
